// locale-unextracted-ignore-file
import { SimpleTable } from '@app/components/base/SimpleTable';
import { Typography } from '@mui/material';
import { fixedWidthColumnProps } from './hls-timeline-fixed-table';
import { formatSeconds } from './hls-timeline-stats';

type HlsTimelineBufferSummaryTableProps = {
  currentTime: number | null;
  maxBufferLength: number | null;
  forwardBufferInfo: { len: number; start: number; end: number } | null;
};

type BufferSummaryRow = {
  currentTime: number | null;
  maxBufferLength: number | null;
  forwardBufferLen: number | null;
  forwardBufferStart: number | null;
  forwardBufferEnd: number | null;
};

/** Single-row table with global playback buffer metrics from hls.js. */
export function HlsTimelineBufferSummaryTable({
  currentTime,
  maxBufferLength,
  forwardBufferInfo,
}: HlsTimelineBufferSummaryTableProps) {
  const summaryRow: BufferSummaryRow = {
    currentTime,
    maxBufferLength,
    forwardBufferLen: forwardBufferInfo?.len ?? null,
    forwardBufferStart: forwardBufferInfo?.start ?? null,
    forwardBufferEnd: forwardBufferInfo?.end ?? null,
  };

  return (
    <>
      <Typography
        variant="caption"
        color="text.secondary"
        sx={{ display: 'block', mb: 0.5, fontWeight: 'bold' }}
      >
        Buffers
      </Typography>
      <SimpleTable
        fixedLayout
        columns={[
          {
            header: 'Current time',
            renderCell: (row) => formatSeconds(row.currentTime),
            ...fixedWidthColumnProps('20%'),
          },
          {
            header: 'Target',
            renderCell: (row) => formatSeconds(row.maxBufferLength),
            ...fixedWidthColumnProps('20%'),
          },
          {
            header: 'Forward (hls.js)',
            renderCell: (row) => formatSeconds(row.forwardBufferLen),
            ...fixedWidthColumnProps('20%'),
          },
          {
            header: 'Start (hls.js)',
            renderCell: (row) => formatSeconds(row.forwardBufferStart),
            ...fixedWidthColumnProps('20%'),
          },
          {
            header: 'End (hls.js)',
            renderCell: (row) => formatSeconds(row.forwardBufferEnd),
            ...fixedWidthColumnProps('20%'),
          },
        ]}
        data={[summaryRow]}
      />
    </>
  );
}
